import * as React from "react";

import Button from "@replo/design-system/components/button/Button";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function NewFunnelButton() {
  const navigate = useNavigate();

  return (
    <Button
      variant="primary"
      size="base"
      onClick={() => {
        navigate(`${window.location.pathname}/new`);
      }}
      startEnhancer={<Plus size={14} />}
    >
      New Funnel
    </Button>
  );
}
